/* Publish by EComposer at 2026-09-30 08:19:27*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ctfwts2uou"]=  window.__ectimmers["ecom-ctfwts2uou"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ctfwts2uou').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ctfwts2uou', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k1hyzfhsauq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k1hyzfhsauq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g7yxjrnznes').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g7yxjrnznes', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2j0j1fzsbm6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2j0j1fzsbm6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x5ljg24g4za').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x5ljg24g4za', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i4x519qgfu8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i4x519qgfu8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3cmf7zxrjg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3cmf7zxrjg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o65x2t9esto').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o65x2t9esto', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gn4nq3yify').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gn4nq3yify', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9x177bdv0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9x177bdv0s', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-phx9yowvzre"]=  window.__ectimmers["ecom-phx9yowvzre"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-phx9yowvzre"]["letumu959"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-phx9yowvzre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-phx9yowvzre', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pkylpmuasyo"]=  window.__ectimmers["ecom-pkylpmuasyo"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-pkylpmuasyo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pkylpmuasyo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}